import React, { useEffect, useState } from 'react';

import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { isEmpty } from 'lodash'
import { Box, Button } from '@material-ui/core';
import { toast } from 'react-toastify';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

const FormClient = (props) => {
    const [clientList, setClientList] = useState({})  
    const [clientListFormatted, setClientListFormatted] = useState([])  
    const [clientListFormattedInitialList, setClientListFormattedInitialList] = useState([])  
    const [inputValue, setInputValue] = useState('');

    const [clientType, setClientType] = useState('particulier');

    const handleChange = (event) => {
      setClientType(event.target.value);
    };
    useEffect(() => {
        if(props.sale.cli_type === "mjb") {
            fetchClientAttribute()
        } 
    }, []);
    useEffect(() => {
        console.log("UPDATE client tel")
    }, [props.client.client_tel]);

    useEffect(() => {
        const clientListFormattedTmp = createClientList()
        setClientListFormatted(clientListFormattedTmp)
        setClientListFormattedInitialList(clientListFormattedTmp)
    }, [clientList]);

    const handleInputChange = (event, newInputValue) => {
        console.log("Update handleInputChange")
        setInputValue(newInputValue);
    
        // Filtrer les options en fonction de la valeur d'entrée
        const filteredOptions = clientListFormattedInitialList.filter(
          (option) => option.label.toLowerCase().indexOf(newInputValue.toLowerCase()) > -1
        );
    
        // Limiter les options filtrées à 100
        setClientListFormatted(filteredOptions.slice(0, 100));
        setInputValue(newInputValue);
      };
      
    const fetchClientAttribute = async () => {
        try {
            const response = await fetch('/user/clients/list/attribute?info=AttributeSale', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            // console.log(resp);
            if (resp.msg != "OK" ){
                console.log("[ERROR], fetchClientAttribute response ",resp)                   
                return;
            }
            let clientList = resp.userID//makeObject(resp.contentHeader, resp.contentArray, resp.userID)
            // console.log("[INFO], fetchClientAttribute data",clientList)
            setClientList(clientList)
        } catch (err) {
            console.log("[ERROR], fetchClientAttribute data",err)
            toast.error("Error fetching clients"+err.message)
        }
    }
    const createClientList = () => {
        const list = [] 
        // IF PAYG client already registered
        // console.log(state.clientList);
        if(props.sale.cli_type === "mjb"){
            if( !isEmpty(clientList) ){
                clientList.map( client => {
                    // const client = item.resume
                    const infos = {
                        client_lastname: client.name,
                        client_firstname: client.boxID,
                        client_tel: client.phone,
                        client_address: client.adress,
                        client_email: client.Email,
                        client_paygo_id:client.id,
                    }
                    list.push ({ 
                        value: client.id, 
                        label:`${client.boxID} : ${client.name} - ${client.adress}`, 
                        infos
                    })
                })
            }

        } else {
            list.push({
                value:"", 
                label:"Créer Un Client", 
                infos:{
                    client_lastname:"",
                    client_firstname:"",
                    client_address:"",
                    client_city:"",
                    client_country:"",
                    
                }
            })

            if( !isEmpty(props.CLIENTS) ){
                Object.values(props.CLIENTS).map( client =>{
                    list.push({
                        value:client.id, 
                        label:`${client.client_firstname} ${client.client_lastname} - ${client.client_city}`, infos:client
                    })
                })
            }
        }
        // console.log("CLIENT LIST", {list});
        
        return list
    }
    const fetchClientDetails = async (boxAssoId) => {
        try {
            const response = await fetch('/user/clients/detail/info?boxAssoId='+boxAssoId, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            // console.log(resp);
            if (resp.msg != "OK" ){
                console.log("[ERROR], fetchClientAttribute response ",resp)    
                toast.error("Error fetching client Info. \n"+resp.error)               
                throw new Error("No info");
            }
            console.log("[INFO], fetchClientDetails data",resp.userInfo)
            return resp.userInfo
        } catch (err) {
            console.log("[ERROR], fetchClientAttribute data",err)
            toast.error("Error fetching client Info \n"+err.message)
        }
    }
    const updateClientSelection = async (option)=>{
        console.log("updateClientSelection >> ",option?.value)
        if (!option) return;
        const idClient = option.value
        let infos = option.infos || {}
        props.handleSelectClient(idClient,infos,option)    

        if(props.sale.cli_type === "mjb" && idClient){
            const boxAssoId = infos?.client_paygo_id || idClient
            try{
                const clientInfo = await fetchClientDetails(boxAssoId)
                if(clientInfo){
                    props.handleSelectClientInfo(boxAssoId,clientInfo)    
                }
            }catch(err){
                // Already handled inside fetchClientDetails
            }
        }
    }

        return (
            <Box>
                
                <InputSelectMagasin
                    options={clientListFormatted.slice(0, 50)}
                    value={props.client.clientDisplay}
                    inputValue={inputValue}
                    onInputChange={handleInputChange}
                    onChange={updateClientSelection}
                    placeholder="Selectionner un Client"
                    label="Client"
                    // error={props.errors.client.client}
                    // value={props.client.clientDisplay|| {value:"", label:""}}
                    // isOptionDisabled={(option) => option.disabled === true}
                /> 
                {!(props.sale.cli_type === "mjb") &&
                <>
                <FormLabel component="legend">Type de client</FormLabel>
                <RadioGroup aria-label="client_type" name="client_type" value={clientType} onChange={handleChange}>
                  <FormControlLabel value="particulier" control={<Radio />} label="Particulier" />
                  <FormControlLabel value="professionnel" control={<Radio />} label="Professionnel" />
                </RadioGroup>
                </>
                }
               {(clientType ==="professionnel") &&
                    <InputText 
                    haserror={(props.errorsClient.client_companyname ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_companyname} 
                    name="client_companyname" 
                    title="Nom entreprise *" 
                    error={props.errorsClient.client_companyname}  />
                }
                {(clientType ==="professionnel") &&
                    <InputText 
                    haserror={(props.errorsClient.client_ifu ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_ifu} 
                    name="client_ifu" 
                    title="Numero IFU *" 
                    error={props.errorsClient.client_ifu} />
                }
                {(clientType ==="professionnel") &&
                    <InputText 
                    haserror={(props.errorsClient.client_rccm ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_rccm} 
                    name="client_rccm" 
                    title="Numero RCCM *" 
                    error={props.errorsClient.client_rccm} />
                }
                <InputText 
                    haserror={(props.errorsClient.client_lastname ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_lastname} 
                    name="client_lastname" 
                    title="Nom *" 
                    error={props.errorsClient.client_lastname} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
                
                <InputText 
                    haserror={(props.errorsClient.client_firstname ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_firstname} 
                    name="client_firstname" 
                    title="Prénom *" 
                    error={props.errorsClient.client_firstname} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
    
                <InputText 
                    haserror={(props.errorsClient.client_tel ? "has-error" : "")}
                    change={props.handleChangeClient} 
                    value={props.client.client_tel} 
                    name="client_tel" 
                    title="Téléphone *" 
                    error={props.errorsClient.client_tel} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
    
                <InputText 
                    haserror={(props.errorsClient.client_email ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_email} 
                    name="client_email" 
                    title="Email" 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
                
                <InputText 
                    haserror={(props.errorsClient.client_address ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_address} 
                    name="client_address" 
                    title="Adresse" 
                    error={props.errorsClient.client_address} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
                
                <InputText 
                    haserror={(props.errorsClient.client_city ? "has-error" : "")} 
                    change={props.handleChangeClient} 
                    value={props.client.client_city} 
                    name="client_city" 
                    title="Ville *" 
                    error={props.errorsClient.client_city} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
                
                <InputText 
                    haserror={(props.errorsClient.client_country ? "has-error" : "")} change={props.handleChangeClient} 
                    value={props.client.client_country} 
                    name="client_country" 
                    title="Pays *"
                    error={props.errorsClient.client_country} 
                    disabled={((props.sale.client_ref || props.sale.cli_type === "mjb") ? true : false)} />
               
            </Box>
        );
}

export default FormClient;